import moment from 'moment';
import { optionsSN } from './options';

export const parseCurrency = (value) => {
  let values = `${(parseFloat(value) || 0).toFixed(2)}`.split('.');
  return `R$ ${`${values[0]}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1.`)},${values[1]}`;
};

export const parseCurrencyMoney = (value) => {
  const values = `${(parseFloat(value) || 0).toFixed(2)}`.split('.');
  return `${`${values[0]}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1.`)},${values[1]}`.split(
    ','
  )[0];
};

export const parseCurrencyCents = (value) => {
  const values = `${(parseFloat(value) || 0).toFixed(2)}`.split('.');
  return values[1];
};

export const parseDatestringBRUS = (datestring) => {
  const ds = `${datestring}`?.split('/');
  return `${ds[2]}-${ds[1]}-${ds[0]}`;
};

export const parseDatestringUSBR = (datestring) => {
  const ds = `${datestring}`?.split('T')?.[0]?.split('-');
  return `${ds[2]}/${ds[1]}/${ds[0]}`;
};

export const unparseCurrency = (value) => {
  return parseFloat(
    value?.replace('R$', '')?.replace(/ |\./g, '')?.replace(',', '.')
  );
};

export const unmaskPhone = (phone) => (phone ? phone.replace(/\D/g, '') : '');

export const formatElapsedTime = (createdAt) => {
  const now = moment();
  const created = moment(createdAt);
  const duration = moment.duration(now.diff(created));
  const days = Math.floor(duration.asDays());
  const hours = duration.hours().toString().padStart(2, '0');
  const minutes = duration.minutes().toString().padStart(2, '0');

  return `${days}d ${hours}h ${minutes}m`;
};

export const formatDocuments = (value) => {
  if (!value) return 'N/A';
  let numbers = String(value).replace(/\D/g, '');
  if (numbers.length === 11) {
    return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (numbers.length === 14) {
    return numbers.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5'
    );
  }
  return numbers;
};

export const formatPhone = (ddd, celular) => {
  const num = `${ddd || ''}${celular || ''}`.replace(/\D/g, '');

  if (!num) return null;

  if (num.length === 11)
    return num.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  if (num.length === 10)
    return num.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  return num ? `(${num.slice(0, 2)}) ${num.slice(2)}` : 'N/A';
};

export const formatCEP = (cep) => {
  if (!cep) return '';
  const numbers = cep.toString().replace(/\D/g, '');
  if (numbers.length !== 8) {
    return numbers;
  }
  return numbers.replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2-$3');
};

export const formatPercentage = (value) => {
  return `${String(value).replace('.', ',')}%`;
};

export const parseSNtoBoolean = (value) => {
  return optionsSN[0].id === value ? true : false;
};
